function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const FileZipIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28.68 7.16c-.693-.948-1.66-2.054-2.723-3.117s-2.17-2.03-3.116-2.724C21.23.136 20.45 0 20 0H4.5C3.122 0 2 1.12 2 2.5v27C2 30.878 3.12 32 4.5 32h23c1.378 0 2.5-1.122 2.5-2.5V10c0-.448-.137-1.23-1.32-2.84zm-4.137-1.703c.96.96 1.712 1.825 2.268 2.543H22V3.19c.718.555 1.584 1.308 2.543 2.267zM28 29.5c0 .27-.23.5-.5.5h-23c-.27 0-.5-.23-.5-.5v-27c0-.27.23-.5.5-.5H20v7c0 .552.448 1 1 1h7v19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2h4v2H8V2zM12 4h4v2h-4V4zM8 6h4v2H8V6zM12 8h4v2h-4V8zM8 10h4v2H8v-2zM12 12h4v2h-4v-2zM8 14h4v2H8v-2zM12 16h4v2h-4v-2zM8 26.5c0 .825.675 1.5 1.5 1.5h5c.825 0 1.5-.675 1.5-1.5v-5c0-.825-.675-1.5-1.5-1.5H12v-2H8v8.5zm6-2.5v2h-4v-2h4z"
  }));
};
export default FileZipIcon;